const i = {
  de: "de",
  dk: "da",
  en: "en",
  it: "it",
  es: "es",
  fr: "fr"
}, g = "en", x = Object.keys(i), z = Object.values(i), c = ["de"], a = (e) => x.includes(e), m = (e) => z.includes(e), U = (e) => c.includes(e), d = (e) => {
  var t;
  const n = e ?? ((t = globalThis.location) == null ? void 0 : t.origin) ?? "";
  return c.find(
    (o) => n.endsWith(`.${o}`)
  );
}, u = (e) => {
  var r;
  const n = e ?? ((r = globalThis.location) == null ? void 0 : r.pathname) ?? "", [t, o] = n.split("/");
  return o;
}, P = () => d() ? "/" : `/${f()}`, f = () => {
  const e = d(), n = u().toLowerCase();
  if (e)
    return e;
  const [t] = n.split("-");
  return a(t) ? t : g;
}, h = () => i[f()], L = (e) => {
  const n = u(e);
  return a(n);
}, T = (e) => {
  if (!L(e)) return e;
  const [, ...n] = e.split("/").filter(Boolean);
  return "/" + n.join("/");
}, $ = (e, n) => {
  const t = P(), o = t === "/" || L(e) ? e : `${t}${e}`;
  if (!n)
    return o;
  const r = new URLSearchParams(
    Object.entries(n).reduce((l, [p, s]) => s ? {
      ...l,
      // Convert number and boolean to string
      [p]: String(s)
    } : l, {})
  );
  return `${o}?${r.toString()}`;
};
export {
  g as defaultLocale,
  d as findLocalizedTopLevelDomain,
  h as getCurrentLocale,
  f as getCurrentUrlPrefix,
  P as getLocalizedBaseUrl,
  u as getUrlPrefix,
  m as isValidLocale,
  U as isValidLocalizedTopLevelDomain,
  a as isValidUrlPrefix,
  i as localeMap,
  z as locales,
  $ as localizeUrl,
  c as localizedTopLevelDomains,
  T as unlocalizePathname,
  x as urlPrefixes
};
//# sourceMappingURL=locale.js.map
